import { Progress } from 'antd';
import React, { FC } from 'react';

interface Props {
  value: number;
}

const strokeColor = '#0E6AED';
const trailColor = '#E8EBED';

export const ProgressBar: FC<Props> = ({ value }) => {
  return (
    <Progress
      percent={100 / (5 / value)}
      showInfo={false}
      strokeColor={strokeColor}
      trailColor={trailColor}
      size="small"
    />
  );
};
